import { render, staticRenderFns } from "./NewSupplierUserModal.vue?vue&type=template&id=3bf231a6&scoped=true&"
import script from "./NewSupplierUserModal.vue?vue&type=script&lang=js&"
export * from "./NewSupplierUserModal.vue?vue&type=script&lang=js&"
import style0 from "./NewSupplierUserModal.vue?vue&type=style&index=0&id=3bf231a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf231a6",
  null
  
)

export default component.exports